const MaterialsList = () =>
  import(
    /* webpackChunkName: "MaterialsList" */ "@/components/atmo/materials/MaterialsList.vue"
  );

export default [
  {
    path: "",
    name: "materials",
    component: MaterialsList,
  },
  {
    path: "/update-material/:materialUuid/",
    redirect: (to) => ({
      name: "materials",
      query: { edit: to.params.materialUuid },
    }),
  },
];
